import { addUserDetails } from "../../features/UserDetailsSlice";
import { nanoid } from "@reduxjs/toolkit";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getPaginationRowModel,
} from "@tanstack/react-table";
import Skeleton from "react-loading-skeleton";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
const StaticTableWithPagination = ({
  columns,
  data,
  loading,
  page,
  currentPage,
  morePage,
  handleFirstPageChange,
  handlePrevPageChange,
  handleNextPageChange,
  removePagination,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageIndex: 0, // initial page index
        pageSize: 20, // default page size set to 20
      },
    },
  });
  return (
    <>
      <div className="commonTable custom-Table" id="dataSubjectTable">
        <table className="table">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className={header.column.columnDef.className}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {loading ? (
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((row) => (
                <tr key={row}>
                  {[1, 2, 3, 4]?.map((col) => (
                    <td key={col}>
                      <Skeleton animation="wave" variant="text" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              {table.getRowModel().rows.length === 0 ? (
                <tr>
                  <td
                    colSpan="4"
                    className="fs-5 py-2 text-center fw-bold text-danger"
                    id="exampleModalLongTitle"
                  >
                    <FormattedMessage
                      id="id.table.no-data"
                      defaultMessage="Data is not available"
                    />
                  </td>
                </tr>
              ) : (
                table.getRowModel().rows.map((row) => (
                  <tr key={row.id} className="table-row">
                    {row.getVisibleCells().map((cell) => (
                      <td
                        className={cell.column.columnDef.className}
                        key={cell.id}
                        role="button"
                        onClick={() => {
                          const {
                            controller_code,
                            customer_scope,
                            type,
                            value,
                            language,
                          } = cell?.row.original;
                          dispatch(
                            addUserDetails({
                              id: nanoid(),
                              type,
                              value,
                              language,
                              controller_code,
                              customer_scope,
                            })
                          );
                          navigate(
                            `/ui/details/?controller=${controller_code}&customer_scope=${customer_scope}&type=${type}&value=${encodeURIComponent(value)}`
                          );
                        }}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          )}
        </table>
      </div>
      {data?.length !== 0 && !removePagination && (
        <div
          id="table-pagination"
          className="pagination d-flex justify-content-end  align-items-center py-3 px-3"
        >
          <span className="px-3">
            <FormattedMessage
              id="id.table.page-of"
              defaultMessage="Page {page}"
              values={{
                page: <strong>{currentPage || 1}</strong>,
              }}
            />
          </span>
          <button
            className="page-item paginator "
            onClick={handleFirstPageChange}
            disabled={page === 1}
          >
            <img
              src="/ui/images/Truman-UI-Table-Start.svg"
              alt="table-first-page"
            />
          </button>{" "}
          <button
            className="page-item paginator  px-2"
            onClick={handlePrevPageChange}
            disabled={page === 1}
          >
            <img
              src="/ui/images/Truman-UI-Table-Prev.svg"
              alt="table-prev-page"
            />
          </button>{" "}
          <button
            className="page-item paginator  px-2"
            onClick={handleNextPageChange}
            disabled={!morePage}
          >
            <img
              src="/ui/images/Truman-UI-Table-Next.svg"
              alt="table-next-page"
            />
          </button>{" "}
        </div>
      )}
    </>
  );
};

export default StaticTableWithPagination;
